function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.497 3.927c-.393 0-.76.2-.973.531L9.53 7.566H5.083A3.083 3.083 0 0 0 2 10.648v14.343a3.083 3.083 0 0 0 3.083 3.082h21.835A3.083 3.083 0 0 0 30 24.991V10.648a3.083 3.083 0 0 0-3.082-3.082H22.47l-1.994-3.108a1.156 1.156 0 0 0-.973-.531h-7.006Zm12.521 5.78a1.605 1.605 0 1 1 0 3.21 1.605 1.605 0 0 1 0-3.21Zm-2.981 7.513a6.037 6.037 0 1 1-12.073 0 6.037 6.037 0 0 1 12.073 0ZM16 20.64a3.42 3.42 0 1 0 0-6.84 3.42 3.42 0 0 0 0 6.84Z"
  }));
};
var componentName = 'CameraFilled';
export var CameraFilled = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
CameraFilled.displayName = componentName;